<template>
  <RequireAdContract>
    <WithCampaignInternalNav>
      <Content
        class="campaign-view"
        :title="$t('ADVERTISEMENT.CAMPAIGN_DETAILS.TITLE')"
      >
        <div class="campaign-view__info">
          <span>{{ $t('ADVERTISEMENT.CAMPAIGN_VIEW.CAMPAIGN_NAME') }}:</span>
          <span>
            {{ campaignInfo.name }}
          </span>
        </div>
        <div class="campaign-view__info">
          <span>{{ $t('ADVERTISEMENT.CAMPAIGN_VIEW.STATUS') }}:</span>
          <span :class="campaignStatusClass">
            {{ $t(translateCampaignStatus(campaignInfo.status)) }}
          </span>
        </div>

        <CampaignViewActions
          :paused="campaignInfo.paused"
          :name="campaignInfo.name"
          @changeStatus="changeCampaignStatus"
        />

        <hr class="divider" />

        <Transition name="fade-transform" mode="out-in">
          <RouterView @update="getCampaignInfo" />
        </Transition>
      </Content>
    </WithCampaignInternalNav>
  </RequireAdContract>
</template>

<script>
import RequireAdContract from '../../common/RequireAdContract';
import layout from '@/mixins/layout';
import permissions from '@/mixins/permissions';

import { DiscoveryAdsCampaigns } from '@/api/api';

import campaignId from '@/mixins/advertisement/campaignId';
import lang from '@/mixins/lang';

import Content from '@@/common/layout/Content';
import CampaignViewActions from './CampaignViewActions';

import WithCampaignInternalNav from './WithCampaignInternalNav';

import translateCampaignStatus from '../../common/utility/translators/translateCampaignStatus';

export default {
  name: 'CampaignView',
  components: {
    RequireAdContract,
    WithCampaignInternalNav,
    Content,
    CampaignViewActions,
  },

  mixins: [layout, permissions, campaignId, lang],

  data() {
    return {
      isLoading: true,

      campaignInfo: {
        name: '',
        status: '',
        paused: false,
      },
    };
  },

  computed: {
    campaignStatusClass() {
      const { status } = this.campaignInfo;
      return {
        'text-success': status === 'active',
        'text-alert': status === 'paused',
        'text-warning': status !== 'active' && status !== 'paused',
      };
    },
  },

  created() {
    this.setPageTitle('ADVERTISEMENT.TITLE');
    this.getCampaignInfo();
  },

  methods: {
    translateCampaignStatus,
    getCampaignInfo() {
      this.isLoading = true;
      return DiscoveryAdsCampaigns.getCampaignInfo(this.campaignId)
        .then(({ name, status, paused }) => {
          this.campaignInfo = {
            name,
            status,
            paused,
          };
        })
        .catch(({ message }) => {
          if (message) {
            this.$message.error(message);
          }
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    changeCampaignStatus() {
      this.campaignInfo.paused = !this.campaignInfo.paused;

      this.getCampaignInfo();
    },
  },
};
</script>

<style lang="scss">
.campaign-view {
  &__info {
    margin-bottom: $global-margin / 2;
  }
}
</style>
